import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { ConfigModel } from '../../../models/config-model';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';

@Component({
  selector: 'app-admin-config',
  templateUrl: './admin-config.page.html',
  styleUrls: ['./admin-config.page.scss'],
})
export class AdminConfigPage implements OnInit {

  configs: any[] = [];
  displayedColumns: string[] = ['key', 'value', 'description'];

  constructor(    
    private restService: RestService,
    private appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.getConfigs();
  }

  open(config: ConfigModel, isNew:boolean) {
    this.dialog.open(ConfigModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { config, isNew }
    }).afterClosed().subscribe((data:{updated:boolean}) => {
      if (!data) {
        return;
      }
      if(data.updated){
        this.getConfigs();
      }      
    });
  }

  setOpen(config?: ConfigModel) {
    Log.debug('config', {config});
    let isNew = false;
    if(config==null){
      isNew = true;
    }
    this.open(Object.assign({}, config), isNew);
  }
  
  getConfigs(){
    this.restService.getConfigs().subscribe(result => {
      Log.debug('getConfigs', result);
      this.configs = result;
    });
  }

}


@Component({
  selector: 'app-config-modal-content',
  templateUrl: './config-modal.component.html',
  styleUrls: ['./admin-config.page.scss']
})
export class ConfigModalContent {
  config: ConfigModel;
  isNew: boolean;
  restrictionText = '{}';
  readonly frontendTypes = ['TEXT', 'NUMBER', 'SELECT', 'DATE', 'DATETIME', 'FILE'];
  readonly restrictionTypes = ['string', 'number', 'boolean'];

  constructor(public activeModal: MatDialogRef<ConfigModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { config: ConfigModel; isNew: boolean },
              private restService: RestService,
              public appService: AppService) {
                this.config = data?.config;
                this.isNew = data?.isNew;
                if (!this.config.restriction) {
                  this.config.restriction = {};
                }
                this.restrictionText = JSON.stringify(this.config?.restriction ?? {}, null, 2);
              }

  get firstRestriction() {
    if (!this.config.restriction) {
      this.config.restriction = {};
    }
    return this.config.restriction;
  }

  get configFieldModel(): ConfigModel {
    return {
      ...this.config,
      restriction: {
        ...(this.config?.restriction ?? {})
      }
    };
  }

  get restrictionOptionsText(): string {
    return this.firstRestriction.options?.join(', ') ?? '';
  }

  set restrictionOptionsText(value: string) {
    this.firstRestriction.options = value
      ? value.split(',').map(option => option.trim()).filter(option => option.length > 0)
      : [];
    this.updateRestrictionText();
  }

  updateRestrictionText() {
    this.restrictionText = JSON.stringify(this.config?.restriction ?? {}, null, 2);
  }

  syncRestrictionFromJson() {
    try {
      this.config.restriction = this.restrictionText?.trim()
        ? JSON.parse(this.restrictionText)
        : {};
      this.restrictionText = JSON.stringify(this.config?.restriction ?? {}, null, 2);
    } catch (error) {
      this.appService.showDangerToast('El JSON de restriction no es valido.');
    }
  }

  confirm(){
      try {
        this.config.restriction = this.restrictionText?.trim()
          ? JSON.parse(this.restrictionText)
          : {};
      } catch (error) {
        this.appService.showDangerToast('El JSON de restriction no es valido.');
        return;
      }

      if(this.isNew){
        this.postConfig(this.config);
      }else{
        this.putConfig(this.config);
      }
  }
  
  delete(){
    this.deleteConfig(this.config);
  }
  
  cancel() {
      this.activeModal.close();
  }

  postConfig(config:ConfigModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.postConfig(config).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.activeModal.close({updated:true});
    });
  }

  putConfig(config:ConfigModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.putConfig(config).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.activeModal.close({updated:true});
    });
  }

  deleteConfig(config:ConfigModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.deleteConfig(config).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.activeModal.close({updated:true});
    });
  }

}
